<template>
	<div>
		<p
			v-if="showDesc"
			class="font-red desc"
			v-text="
				'유저가 앱내에서 인스타그램 URL을 빈값으로 수정하였으므로 해당 유저의 인스타그램 내역의 삭제일 동일하게 반영하였습니다.'
			"
		/>
		<table class="table-main history">
			<thead>
				<tr>
					<th v-for="th in thList" :key="th">{{ th }}</th>
				</tr>
			</thead>
			<template v-if="tableData">
				<template v-if="tableData.length">
					<tbody v-for="(obj, objIdx) in tableData" :key="objIdx">
						<tr v-for="(item, idx) in obj.changeList" :key="idx">
							<td
								v-if="idx === 0"
								:rowspan="obj.changeList.length"
							>
								{{ obj.created_at }}
							</td>
							<td class="text-left history__key">
								{{ item.key }}
							</td>
							<td class="text-left">
								<span
									v-html="item.cur"
									class="history__current"
								/>
							</td>
							<td v-html="item.before" class="text-left" />
							<td
								v-if="params.type === 'instagram'"
								v-text="item.deletedAt"
							/>
						</tr>
					</tbody>
				</template>
				<tbody v-else>
					<tr>
						<td :colspan="thList.length">변경이력이 없습니다.</td>
					</tr>
				</tbody>
			</template>
			<tbody v-else>
				<tr>
					<td :colspan="thList.length">불러오는 중...</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import moment from 'moment';
	import { mapState } from 'vuex';

	export default {
		name: 'ShowHistory',
		data() {
			return {
				thList: ['변경시간', '항목', '변경 후', '변경 전'],
				tableData: null,
				showDesc: false,
			};
		},
		computed: {
			...mapState({
				params: state => state.modal.params,
			}),
		},
		created() {
			if (this.params.type === 'instagram') {
				this.thList.push('삭제시간');
				this.getInstaHistory();
			} else {
				this.getTableData();
			}
		},
		methods: {
			getChanges({ doc, before_doc }) {
				return this.params.keyList.reduce((acc, key) => {
					if (
						doc.hasOwnProperty(key) ||
						before_doc.hasOwnProperty(key)
					) {
						acc.push({
							key,
							cur: doc[key],
							before: before_doc[key],
						});
					}
					return acc;
				}, []);
			},
			async getTableData() {
				try {
					const params = {
						ref_type: 'register',
						type: this.params.type,
						ref_id: this.params.refId,
					};
					const {
						data: { change_logs },
					} = await this.$axiosSupport.get('/admin/change_log', {
						params,
					});
					this.tableData = change_logs.map(item => ({
						created_at: moment(item.created_at).format(
							'YYYY-MM-DD HH:mm'
						),
						changeList: this.getChanges(item),
					}));
				} catch (err) {
					console.error(err);
					alert(
						'목록을 가져오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},

			getChangeHistory(data) {
				const sortedData = [...data].sort((a, b) => b.createdAt - a.createdAt);
				const history = [];

				for (let i = 1; i < sortedData.length; i++) {
					const latest = sortedData[i - 1];
					const previous = sortedData[i];
					const latestUrl = latest?.doc.instagram.url;
					const previousUrl = previous?.doc.instagram.url;

                    if (latest.deletedAt) {
                        this.showDesc = true;
                    }

                    history.push({
                        created_at: moment(latest.createdAt).format('YYYY-MM-DD HH:mm'),
                        changeList: [
                            {
                                key: 'url',
                                cur: latestUrl ? latestUrl.toString() : '',
                                before: previousUrl
                                    ? previousUrl.toString()
                                    : '',
                                deletedAt: latest.deletedAt
                                    ? moment(latest.deletedAt).format(
                                            'YYYY-MM-DD HH:mm'
                                        )
                                    : '',
                            },
                        ],
                    });
				}
				return history;
			},
			async getInstaHistory() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/registers/${this.params.refId}/external-advertising`
					);
					this.tableData = this.getChangeHistory(data);
				} catch (err) {
					console.error(err);
					alert(
						'목록을 가져오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.desc {
		margin-top: 18px;
	}
	.history {
		margin-top: 18px;

		tbody {
			border: solid 1px #dfe6ee;

			&:hover {
				background: #f4f7fa;
			}

			&:nth-child(odd) {
				background-color: rgb(255, 250, 205);
			}

			&:first-of-type .history__current {
				display: inline-block;
				background: $btn-blue;
				padding: 4px 6px;
				border-radius: 8px;
				vertical-align: middle;
				line-height: 16px;
				color: white;
			}
		}

		tr:hover {
			background-color: transparent;
		}

		td.history__key {
			font-weight: bold;
		}
	}
</style>
